import { render, staticRenderFns } from "./PhonesGridContent.vue?vue&type=template&id=4ad09eb3"
import script from "./PhonesGridContent.vue?vue&type=script&lang=ts"
export * from "./PhonesGridContent.vue?vue&type=script&lang=ts"
import style0 from "./PhonesGridContent.vue?vue&type=style&index=0&id=4ad09eb3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports